import { MouseEvent, ReactNode } from 'react'
import styles from './DiaHeader.module.css'

// Look & feel (club, 2026-10-23): "estos 3 puntos en la cabecera con el día mezclado no me gusta como
// queda". La cabecera de cada sesión es ahora una pequeña hoja de calendario (día de la semana, número
// y, en F11, nº de sesión o ⚽), y toda la cabecera es el botón del menú del día (antes un «⋮» suelto
// junto al texto); un ▾ discreto indica que se puede pulsar. Sin `onOpen` (solo lectura) no hay botón.
export function DiaHeader({
  semana,
  dia,
  extra,
  onOpen,
  children,
}: {
  semana: string
  dia: number | string
  extra?: ReactNode
  onOpen?: (e: MouseEvent<HTMLButtonElement>) => void
  children?: ReactNode
}) {
  const contenido = (
    <>
      <span className={styles.semana}>{semana}</span>
      <span className={styles.dia}>{dia}</span>
      {extra != null && extra !== '' && <span className={styles.extra}>{extra}</span>}
    </>
  )
  return (
    <div className={styles.contenedor}>
      {onOpen ? (
        <button type="button" aria-label="estado-dia" aria-haspopup="menu" className={styles.boton} onClick={onOpen}>
          {contenido}
          <span className={styles.chevron} aria-hidden>
            ▾
          </span>
        </button>
      ) : (
        <div className={styles.hoja}>{contenido}</div>
      )}
      {children}
    </div>
  )
}
